import {DomainSequenceType} from 'antibodies/domain-annotation/DomainAnnotationTypes';
import {AntibodyComponentSchemaInterfaceApiId} from 'antibodies/schema-configuration/AntibodySchemaInterfaceConstants';
import {TagSchemaItemType} from 'graphql-client/__generated/graphqlGlobalTypes';

export const DOMAIN_INTERFACE_ID_BY_SEQUENCE_TYPE: Record<
  DomainSequenceType,
  AntibodyComponentSchemaInterfaceApiId
> = {
  [DomainSequenceType.AA]: AntibodyComponentSchemaInterfaceApiId.AA_DOMAIN_ID,
  [DomainSequenceType.DNA]: AntibodyComponentSchemaInterfaceApiId.DNA_DOMAIN_ID,
};

/** Domain SSIs can only be implemented by AA and DNA sequence schemas. */
export function getDomainSequenceType(itemType: TagSchemaItemType): DomainSequenceType | null {
  switch (itemType) {
    case TagSchemaItemType.AA_SEQUENCE:
      return DomainSequenceType.AA;
    case TagSchemaItemType.DNA_SEQUENCE:
      return DomainSequenceType.DNA;
    default:
      return null;
  }
}
